<script setup lang="ts">
import { computed } from "vue";

import { useUser } from "@/composables/api/useUser";
import { rewards as rewardsReferential } from "@/rewards";

import GiftProduct from "./GiftProduct.vue";

const { data: user } = useUser();

const STAGGER_DELAY = 100;
const BASE_DURATION = 500;

const rewards = computed(() => {
  if (!user.value?.current_mechanic) {
    return [];
  }
  const mechanic = user.value.current_mechanic;
  return rewardsReferential[mechanic];
});

function onBeforeEnter(el: HTMLElement) {
  el.style.opacity = "0";
  el.style.transform = "translateY(30px)";
}

function onEnter(el: HTMLElement, done: () => void) {
  const delay = Number(el.dataset.index) * STAGGER_DELAY;

  setTimeout(() => {
    el.style.transition = `all ${BASE_DURATION}ms cubic-bezier(0.4, 0, 0.2, 1)`;
    el.style.opacity = "1";
    el.style.transform = "translateY(0)";
  }, delay);

  setTimeout(done, delay + BASE_DURATION);
}
</script>

<template>
  <TransitionGroup
    tag="div"
    class="-mr-8 -ml-8 flex w-full flex-wrap items-center justify-center gap-10"
    :css="false"
    @beforeEnter="onBeforeEnter($event as HTMLElement)"
    @enter="(el, done) => onEnter(el as HTMLElement, done)"
  >
    <GiftProduct
      v-for="(reward, index) in rewards"
      :key="index"
      :data-index="index"
      :reward="reward"
    />
  </TransitionGroup>
</template>
